import { FaCalendarCheck, FaUsers } from 'react-icons/fa';
import SectionCard from './SectionCard';
import { IconSelect } from 'components/VegasConference';
import { currencyFormatter } from 'services/helpers';

const attendanceOptions = [
  { value: 'yes', label: 'Yes, I am coming' },
  { value: 'no', label: 'No, I am not coming' }
];

const personOptions = Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));

const AttendanceDetails = ({ isAttending, totalPersons, setIsAttending, setTotalPersons }) => {
  return (
    <SectionCard
      icon={FaCalendarCheck}
      title="Attendance Details"
      subtitle="Let us know who will be joining."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {attendanceOptions.map((o) => {
          const isActive = isAttending === o.value;
          return (
            <label
              key={o.value}
              className={`flex items-center gap-3 h-14 px-4 rounded-xl border cursor-pointer transition
                ${
                  isActive
                    ? 'border-[#13235f] bg-[#13235f]/5 text-[#13235f] font-semibold'
                    : 'border-slate-200 text-slate-600 hover:border-slate-300'
                }`}
            >
              <input
                type="radio"
                name="attendance"
                value={o.value}
                checked={isActive}
                onChange={(e) => setIsAttending(e.target.value)}
                className="accent-[#13235f] w-4 h-4"
              />
              <span className="text-sm">{o.label}</span>
            </label>
          );
        })}
      </div>

      <label className="block text-sm font-medium text-slate-600 mb-2">
        Total Number of Persons
      </label>
      <IconSelect
        icon={FaUsers}
        label="Total Number of Persons"
        value={totalPersons}
        onChange={(value) => setTotalPersons(parseInt(value))}
        options={personOptions}
      />

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mt-4">
        <p className="m-0 text-xs text-slate-500">
          {isAttending === 'yes'
            ? `You are included. ${totalPersons - 1} additional attendee(s) will be registered.`
            : `You are not attending. All ${totalPersons} attendees must be entered below.`}
        </p>

        <p className="m-0 text-sm font-semibold text-[#13235f] whitespace-nowrap">
          Total: {currencyFormatter.format(595 * totalPersons)}
          <span className="font-normal text-slate-500"> for {totalPersons} person(s)</span>
        </p>
      </div>
    </SectionCard>
  );
};

export default AttendanceDetails;
